<template>
    <div>
<!--        <breadcrumb :routerList="[{title:'返利明细报表'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                        <div class="h-thirdColumn w-newColumn">
                            <el-form-item label="工贸">
                                <brselect category="FlSalesOrganization_agent" :v="q.vkorg" v-model="q.vkorg"
                                          :clearable="true"
                                          style="width:100%;"/>
                            </el-form-item>
                            <el-form-item label="客户名称/编码">
                                <el-input v-model="q.kunnrName" :v="q.kunnrName" style="width: 100%"></el-input>
                            </el-form-item>
                            <el-form-item label="奖励号">
                                <el-input v-model="q.zxh" :v="q.zxh"></el-input>
                            </el-form-item>
                            <el-form-item label="是否核销">
                                <brselect category="iscancel" :v="q.zsfhx" v-model="q.zsfhx"
                                          :clearable="true"/>
                            </el-form-item>
                        </div>
                        <el-collapse-transition>
                            <div v-show="isScreen">
                                <div class="h-thirdColumn w-newColumn">
                                    <el-form-item label="贷项凭证">
                                        <el-input v-model="q.vbeln2" :v="q.vbeln2"></el-input>
                                    </el-form-item>
                                    <el-form-item label="纸质发票号">
                                        <el-input v-model="q.bktxt" :v="q.bktxt"></el-input>
                                    </el-form-item>
                                    <el-form-item label="凭证号">
                                        <el-input v-model="q.vbelnFi" :v="q.vbelnFi"></el-input>
                                    </el-form-item>
                                    <el-form-item label="奖励年度">
                                        <el-date-picker
                                                v-model="q.zksrq"
                                                clearable
                                                type="year"
                                                value-format="yyyy">
                                        </el-date-picker>
                                    </el-form-item>
                                </div>
                                    <div class="h-thirdColumn w-newColumn">
                                    <el-form-item label="凭证日期" style="width: 50%;">
                                        <el-date-picker
                                                v-model="q.zdatebegin"
                                                clearable
                                                type="date"
                                                value-format="yyyy-MM-dd">
                                        </el-date-picker>
                                        <span class="w-time-to">至</span>
                                        <el-date-picker
                                                v-model="q.zdateend"
                                                clearable
                                                type="date"
                                                value-format="yyyy-MM-dd">
                                        </el-date-picker>
                                    </el-form-item>
                                        <el-form-item label="系统发票号">
                                            <el-input v-model="q.vbelnBil" :v="q.vbelnBil"></el-input>
                                        </el-form-item>
                                        <el-form-item label="是否已作废">
                                            <brselect category="iscancel" :v="q.zfbj" v-model="q.zfbj"
                                                      :clearable="true"/>
                                        </el-form-item>
                                </div>
                            </div>
                        </el-collapse-transition>
                    </el-form>
                    <div class="l-screenBox">
                        <div class="l-screen" @click="collapseChange">
                            <img :src="isScreen?closeScreen:drawScreen" alt="">
                            <div class="l-screenText">{{isScreen?"收起":"下拉"}}</div>
                        </div>
                        <div class="l-retrieval">
                            <el-button class="h-btn h-formBtn" @click="search">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-row">

                <div class="h-rowIn" style="width:100%;">
                    <div style="color: red;font-size: 12px;">*数据于每日11:30、15:30、17:30、23:30更新，请以更新后的数据为准。如需对账请查看客户明细账，路径：资金详情—查看—客户明细账数据</div>
                    <el-table @selection-change="handleSelectionChange"
                              ref="multipleTable"
                              :span-method="objectSpanMethod"
                              :data="tableData"
                              stripe
                              :border="true"
                              :summary-method="getSummaries"
                              show-summary
                              max-height="450"
                              style="width: 100%">
                        <el-table-column
                                type="selection"
                                width="40"
                        >
                        </el-table-column>
                        <el-table-column
                                type="index"
                                width="40"
                                label="#"
                                fixed>
                        </el-table-column>
                        <el-table-column
                                prop="zxh"
                                fixed
                                label="流水号"
                                min-width="120"
                                :show-overflow-tooltip="true"
                        >
                            <template scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.zxh}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="vkorgName"
                                :show-overflow-tooltip="true"
                                label="工贸"
                                width="180">
                            <template scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.vkorgName}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="kunnr"
                                :show-overflow-tooltip="true"
                                label="客户编码"
                                width="120">
                            <template scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.kunnr}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="kunnrName"
                                :show-overflow-tooltip="true"
                                label="客户名称"
                                width="180">
                            <template scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.kunnrName}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="zfllx"
                                :show-overflow-tooltip="true"
                                label="奖励名称"
                                width="140">
                            <template scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.zfllx}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="zxh"
                                :show-overflow-tooltip="true"
                                label="奖励号"
                                width="120">
                            <template scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.zxh}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="zksrq"
                                :show-overflow-tooltip="true"
                                label="开始日期"
                                width="100">
                            <template scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.zksrq}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="zjsrq"
                                :show-overflow-tooltip="true"
                                width="100"
                                label="截止日期">
                            <template scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.zjsrq}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="zcjrq"
                                :show-overflow-tooltip="true"
                                width="100"
                                label="下发日期">
                            <template scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.zcjrq}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="zjsje"
                                :show-overflow-tooltip="true"
                                width="100"
                                label="基数">
                            <template scope="scope">
                                <div style="text-align: right;">
                                    {{Number(scope.row.zjsje).toFixed(2)}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="zjlje"
                                :show-overflow-tooltip="true"
                                width="100"
                                label="应兑">
                            <template scope="scope">
                                <div style="text-align: right;">
                                    {{Number(scope.row.zjlje).toFixed(2)}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="zydje"
                                :show-overflow-tooltip="true"
                                width="100"
                                label="已兑">
                            <template scope="scope">
                                <div style="text-align: right;">
                                   {{Number(scope.row.zydje).toFixed(2)}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="zwdje"
                                :show-overflow-tooltip="true"
                                width="100"
                                label="未兑">
                            <template scope="scope">
                                <div style="text-align: right;">
                                    {{Number(scope.row.zwdje).toFixed(2)}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="zfbj"
                                :show-overflow-tooltip="true"
                                width="100"
                                label="是否作废">
                                <template slot-scope="scope">
                                    {{scope.row.zfbj | dictname('iscancel')}}
                                </template>
                        </el-table-column>
                        <el-table-column
                                prop="zsfhx"
                                :show-overflow-tooltip="true"
                                width="100"
                                label="是否核销">
                            <template slot-scope="scope">
                                {{scope.row.zsfhx | dictname('iscancel')}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="vbeln2"
                                :show-overflow-tooltip="true"
                                width="160"
                                label="贷项凭证">
                            <template scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.vbeln2}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="bktxt"
                                :show-overflow-tooltip="true"
                                width="160"
                                label="纸质发票号">
                            <template scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.bktxt}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="vbelnBil"
                                :show-overflow-tooltip="true"
                                width="160"
                                label="系统发票号">
                            <template scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.vbelnBil}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="vbelnFi"
                                :show-overflow-tooltip="true"
                                width="160"
                                label="凭证号">
                            <template scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.vbelnFi}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="zdate"
                                :show-overflow-tooltip="true"
                                width="160"
                                value-format="yyyy-MM-dd"
                                label="凭证日期">
                        </el-table-column>
                        <el-table-column
                                prop="netwr"
                                :show-overflow-tooltip="true"
                                width="160"
                                label="金额">
                            <template slot-scope="scope">
                                <div style="text-align: right;">{{scope.row.netwr?Number(scope.row.netwr).toFixed(2):null}}</div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="h-tableB h-mrt30">
                        <div class="h-tableBL">
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                       @click="exportExcel">批量导出
                            </el-button>
                          <el-button class="h-btn h-formBtn h-bgblueQ"
                                     @click="zfPushSAP" v-auth="'fl_zf_duixian'">作废推sap
                          </el-button>
                        </div>
                        <div class="h-pagination2">
                            <pagination :page="q" @query="search"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile'
    import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'

    export default {
        data() {
            return {
                // 展开折叠筛选
                isScreen: false,
                closeScreen: require("@/assets/images/pimg/closeallic.png"),
                drawScreen: require("@/assets/images/pimg/dobleArr.png"),
                //table列表
                tableData: [],
                spanArr: [],
                q: {
                    vkorg : null,
                    kunnrName : null,
                    zxh : null,
                    zfbj : null,
                    vbeln2 : null,
                    bktxt : null,
                    vbelnFi : null,
                    zksrq : null,
                    zdatebegin : null,
                    zdateend : null,
                    zsfhx:null,
                    vbelnBil:null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                cash:{
                  zjlje:null,
                  zydje:null,
                  zwdje:null,
                },
            }
        },
        created() {
            this.q = {
                vkorg : null,
                kunnrName : null,
                zxh : null,
                vbeln2 : null,
                bktxt : null,
                vbelnFi : null,
                zksrq : null,
                zdatebegin : null,
                zdateend : null,
                vbelnBil:null,
                pageSize: 10,
                pageNo: 1,
                total: 0,
                zsfhx:0,
                zfbj:0
            };
          this.q.zxh = this.$route.query.zxh || null
            this.search();
            this.userCode = this._user.usercode;
        },
        methods: {
          zfPushSAP(){
            var idlist = [];
            if (this.multipleSelection.length < 1) {
              this.$message.error("请选择要作废的数据！");
              return;
            }
              if(this.multipleSelection){
                  this.multipleSelection.forEach(element => {
                      idlist.push(element.zxh);
                  });
              }

              this.$msg.confirm("确认作废未核销返利传sap?", () => {
                ss.fanli.zfPushSAP(idlist).then(rd => {
                  this.$msg.msgs(rd.msg);
                  this.search();
                });
              });
          },
            // 展开折叠
            collapseChange() {
                this.isScreen = !this.isScreen;
            },
            getSpanArr() {
                this.spanArr = [];
                this.tableData.forEach((item, index) => {
                    if (index === 0) {
                        this.spanArr.push(1);
                        this.position = 0;
                    } else {
                        if (this.tableData[index].zxh === this.tableData[index - 1].zxh) {
                            this.spanArr[this.position] += 1;
                            this.spanArr.push(0);
                        } else {
                            this.spanArr.push(1);
                            this.position = index;
                        }
                    }
                })
            },
//合并单元行方法
            objectSpanMethod({row, column, rowIndex, columnIndex}) {
                //需要合并单元行的是哪几列
                if (column.label == "流水号" || column.label == "工贸" || column.label == "客户编码" ||
                    column.label == "客户名称" || column.label == "奖励名称" || column.label == "奖励号" ||
                    column.label == "开始日期" || column.label == "截止日期" || column.label == "下发日期"
                    || column.label == "基数" || column.label == "应兑" || column.label == "已兑" || column.label == "未兑"
                    || column.label == "是否作废" || column.label == "是否核销"
                ) {

                    //从游标集取到对应行下标位置的行重复记录数字，作为需要被合并多少行的rowspan数(该行跨了几行)
                    const _row = this.spanArr[rowIndex];

                    //该行跨了几列
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }

            },
            //重置检索项
            resetData() {
                this.q.vkorg = null;
                this.q.kunnrName = null;
                this.q.zxh = null;
                this.q.zfbj = 0;
                this.q.vbeln2 = null;
                this.q.bktxt = null;
                this.q.vbelnFi = null;
                this.q.zksrq = null;
                this.q.zdatebegin = null;
                this.q.zdateend = null;
                this.q.zsfhx = 0;
                this.q.vbelnBil = null;
            },
          search(){
            this.query();
            this.queryTotal();
          },
            query() {
                ss.fanli.selectDuiXianPage(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                    this.getSpanArr();
                })
            },
          queryTotal() {
            ss.fanli.selectDuiXianTotal(this.q).then(rd=>{
              this.cash = rd.obj;
            });

          },
            //勾选
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            //批量导出
            exportExcel() {
                var idlist = [];
                if(this.multipleSelection){
                    this.multipleSelection.forEach(element => {
                        idlist.push(element.vbeln2);
                    });
                }
                if(idlist.length>0){
                    updownfile.down("/api/swyl/v1/fanli/duixian/flCash/downloadIdExcel", idlist, "post", 'data');
                }else{
                    updownfile.down("/api/swyl/v1/fanli/duixian/flCash/downloadQExcel", this.q, "post");
                }

            },
          getSummaries(param){
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
              if (index === 2) {
                sums[index] = '总计';
                return;
              }
              sums[0] = '';
              sums[1] = '';
              sums[3] = '';
              sums[4] = '';
              sums[5] = '';
              sums[6] = '';
              sums[7] = '';
              sums[8] = '';
              sums[9] = '';
              sums[10] = '';
              sums[11] = '';
              sums[15] = '';
              sums[16] = '';
              sums[17] = '';
              sums[18] = '';
              sums[19] = '';
              sums[20] = '';
              sums[21] = '';
              sums[12] = Number(this.cash.zjlje).toFixed(2);
              sums[13] = Number(this.cash.zydje).toFixed(2);
              sums[14] = Number(this.cash.zwdje).toFixed(2);


              const values = data.map(item => Number(item[column.property]));
            });

            return sums;
          },
        }
    }
</script>

<style>
    .yonghu .h-formbLine .h-elformWrap-2 {
        width: 50%;
    }

    .yonghu .h-dialogForm .h-elformWrap-2 .el-form-item__label {
        width: 41%;
    }

    .yonghu .h-dialogForm .h-elformWrap-2 .el-form-item__content {
        width: 59%;
    }

    .yonghu .h-formbLine .el-form-item__content .el-select {
        width: 100% !important;
    }


    .h-dialog3.dialogFormVisible3 .el-dialog__body {
        padding: 0 0.5rem 0.3rem 0.5rem;
    }


    .h-dialog3.dialogFormVisible3 .el-dialog__body .el-upload--picture-card {
        width: 100%;
        height: 103px;
        border: 1px dashed #7c9ec0;
        background: 0;
        line-height: 103px;
        margin-top: 20px;
        color: #4b4b4b;
        font-size: 18px;
    }
</style>
<style lang="scss">
.el-table thead.is-group th {
  background-color: #57aefe;
}

.w-content .el-table__footer-wrapper .cell {
  text-align: right;
}

.w-content .el-table__fixed-footer-wrapper tbody td {
  background: #cce7ff;
}

.w-content .el-table__footer-wrapper tbody td {
  background: #cce7ff;
}

.el-table--scrollable-x .el-table__body-wrapper {
  z-index: 1;
}

.el-table__fixed, .el-table__fixed-right {
  box-shadow: none;
}

.el-table__fixed, .el-table__fixed-right {
  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    content: '';
    z-index: 100;
    box-shadow: 0 0 10px rgba(0, 0, 0, .12);
  }
}

.el-table__fixed-footer-wrapper tbody td {
  border-top: 0;
}
</style>
